"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.upgrade.subject': 'Konto zostało pomyślnie uaktualnione',
    'email.upgrade.title': 'Twoje konto zostało uaktualnione!',
    'email.upgrade.text': 'Świetne wiadomości! Twoje konto zostało pomyślnie uaktualnione i masz teraz dostęp do zaawansowanych funkcji.',
    'email.upgrade.new_plan': 'Nowy Plan',
    'email.upgrade.benefits': 'Możesz teraz korzystać ze wszystkich korzyści swojego nowego planu subskrypcji.',
    'email.upgrade.dashboard_button': 'Przejdź do panelu',
    'email.upgrade.footer': 'Dziękujemy za wybór IntHub!',
};
